(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aeris-before-after"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCompare(el) {
    var range = el.querySelector('.ba__range');
    if (!range || el.dataset.baInit) return;
    el.dataset.baInit = 'true';

    function update(val) {
      el.style.setProperty('--ba-pos', val + '%');
    }

    range.addEventListener('input', function () {
      update(range.value);
    });

    update(range.value);
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-ba-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aeris-urgency-trust"] && !Shopify.designMode) return;
  try {
    (function() {
  var blocks = document.querySelectorAll('.aeris-ut');
  blocks.forEach(function(block) {
    var countEl = block.querySelector('[data-min]');
    if (!countEl) return;
    var min = parseInt(countEl.dataset.min, 10) || 18;
    var max = parseInt(countEl.dataset.max, 10) || 47;
    var interval = (parseInt(countEl.dataset.interval, 10) || 30) * 1000;
    var current = Math.floor(Math.random() * (max - min + 1)) + min;
    countEl.textContent = current;
    setInterval(function() {
      var delta = Math.floor(Math.random() * 5) - 2;
      current = Math.min(max, Math.max(min, current + delta));
      var prev = parseInt(countEl.textContent, 10);
      if (prev === current) return;
      countEl.style.transition = 'opacity 0.3s';
      countEl.style.opacity = '0';
      setTimeout(function() {
        countEl.textContent = current;
        countEl.style.opacity = '1';
      }, 300);
    }, interval);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
